import { Controller } from "@hotwired/stimulus"
import { lazyImport } from "../lib/lazy_import"

import { enterFullscreen } from '../../assets/vendor/reveal.js/js/utils/util'
import "../../assets/vendor/reveal.js/css/reveal.css"
import "../../assets/vendor/reveal.js/css/theme/source/black.css"
import "../../assets/vendor/reveal.js/css/theme/source/black.css"
import "../../assets/stylesheets/reveal-overrides.css"

export default class extends Controller {
  static targets = ["root"]
  static values = {
    embedded: { type: Boolean, default: true },
    overview: { type: Boolean, default: false }
  }


  connect() {
    this.setupPresentation()
  }

  async setupPresentation() {
    if (this._presentation) { return }

    // reveal.js is only needed on presentation pages; the CSS stays a static
    // import above because esbuild does not load CSS for dynamic chunks.
    const { default: Reveal } = await lazyImport("reveal")
    if (this._presentation || !this.element.isConnected) { return }

    this._presentation = new Reveal()
    this._presentation.initialize(
      {
        embedded: this.embeddedValue,
        overview: this.overviewValue
      }
    )
  }

  disconnect() {
    if (!this._presentation) { return }

    this._presentation.destroy()
    this._presentation = null
  }

  async goFullscreen(event) {
    event.preventDefault()
    await this.setupPresentation()

    enterFullscreen(this._presentation.getViewportElement())
  }
}
